
export const EMPTY_GUID: string = "00000000-0000-0000-0000-000000000000";
export const ALL_ONE: string = "11111111-1111-1111-1111-111111111111";
export const ALL_TWO: string = "22222222-2222-2222-2222-222222222222";
export const ALL_THREE: string = "33333333-3333-3333-3333-333333333333";

//#region Contact Constants
//#endregion